import React, { useState } from 'react';
import { mobileSatsueiService } from '../services/mobileSatsueiService';
import { useApiError } from '../../shared/hooks/useApiError';
import { MessageDialog } from '../../shared/ui';

const MovieReshootModal = ({ 
  isOpen, 
  onClose, 
  objectId, 
  movies, 
  movieData, 
  onMovieReshoot,
  satsueiMemoCategoryId,
  objectIdAutoFlg,
  userKyotenId,
  imageFolderId,
  satsueiGuideId,
  backUrl,
  isSaveLocal
}) => {
  // APIエラーハンドリングフック
  const { 
    showErrorDialog,
    errorMessage,
    handleApiError,
    closeErrorDialog
  } = useApiError(() => setIsLoading(false));
  
  // UI状態
  const [isLoading, setIsLoading] = useState(false); // ローディング状態

  // 動画再撮影処理
  const handleReshootMovie = async (movieIndex) => {
    try {
      setIsLoading(true);
      
      const movieDataItem = movieData[movieIndex];
      if (!movieDataItem) {
        return;
      }

      // カメラ起動用データを準備
      const cameraData = await mobileSatsueiService.prepareCameraData({
        objectId: objectId,
        satsueiMemoCategoryId: satsueiMemoCategoryId || '',
        userKyotenId: userKyotenId || '0',
        imageFolderId: imageFolderId || 0,
        satsueiGuideId: satsueiGuideId || '',
        backUrl: (backUrl || '') + '?objectId=' + objectId + '&objectIdAutoFlg=' + objectIdAutoFlg + '&from=search',
        isSaveLocal: isSaveLocal || '',
        target: 'change',
        startMovieOrderIndex: movieIndex
      });

      // ネイティブアプリのカメラを起動
      mobileSatsueiService.startUpCamera(cameraData);
      console.log('📷cameraData', cameraData);
      
      // 親コンポーネントに再撮影を通知
      if (onMovieReshoot) {
        onMovieReshoot(movieIndex);
      }
      
      onClose();
      
    } catch (error) {
      handleApiError(new Error('カメラの起動に失敗しました。'));
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  const styles = {
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 3000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalContent: {
      background: 'white',
      padding: '20px',
      borderRadius: '10px',
      maxWidth: '90%',
      maxHeight: '90%',
      overflow: 'auto',
      width: '90%'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      paddingBottom: '10px',
      borderBottom: '1px solid #ddd'
    },
    title: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    },
    closeButton: {
      background: '#666',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      padding: '8px 16px',
      cursor: 'pointer',
      fontSize: '14px'
    },
    movieList: {
      maxHeight: '400px',
      overflowY: 'auto'
    },
    movieItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '5px',
      marginBottom: '10px',
      backgroundColor: '#f9f9f9',
      justifyContent: 'space-between'
    },
    leftContent: {
      display: 'flex',
      alignItems: 'center',
      flex: 1
    },
    movieNumber: {
      width: '30px',
      textAlign: 'center',
      fontWeight: 'bold',
      marginRight: '10px'
    },
    movieThumbnail: {
      width: '60px',
      height: '60px',
      objectFit: 'contain',
      borderRadius: '5px',
      marginRight: '20px',
      backgroundColor: '#2B2222',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '12px'
    },
    reshootButton: {
      background: '#f0f0f0',
      color: '#333',
      border: '1px solid #ccc',
      borderRadius: '5px',
      padding: '8px 16px',
      cursor: 'pointer',
      fontSize: '14px',
      width: '60%'
    },
    reshootButtonDisabled: {
      background: '#ccc',
      color: '#666',
      border: 'none',
      borderRadius: '5px',
      padding: '8px 16px',
      cursor: 'not-allowed',
      fontSize: '14px',
      minWidth: '80px'
    },
    loadingText: {
      textAlign: 'center',
      color: '#666',
      fontSize: '14px',
      margin: '20px 0'
    }
  };

  return (
    <div style={styles.modal}>
      <div style={styles.modalContent}>
        <div style={styles.header}>
          <div style={styles.title}>動画再撮影</div>
          <button style={styles.closeButton} onClick={onClose}>
            戻る
          </button>
        </div>

        {isLoading ? (
          <div style={styles.loadingText}>カメラを起動しています...</div>
        ) : (
          <div style={styles.movieList}>
            {movies && movies.length > 0 ? (
               movies.map((movie, index) => (
                 <div key={index} style={styles.movieItem}>
                   <div style={styles.leftContent}>
                     <div style={styles.movieNumber}>{index + 1}</div>
                     <div style={styles.movieThumbnail}>
                       動画
                     </div>
                   </div>
                   <button 
                     style={styles.reshootButton}
                     onClick={() => handleReshootMovie(index)}
                     disabled={isLoading}
                   >
                     再撮影
                   </button>
                 </div>
               ))
            ) : (
              <div style={styles.loadingText}>動画がありません</div>
            )}
          </div>
        )}
      </div>

      {/* Error Dialog */}
      <MessageDialog
        isOpen={showErrorDialog}
        onClose={closeErrorDialog}
        title="メッセージ"
        message={errorMessage}
        type="error"
      />
    </div>
  );
};

export default MovieReshootModal;
